module.exports = __webpack_public_path__ + "img/sy_cpzx@3x.aefc937a.png";